var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManualTest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#ff1414",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("title", null, "computer-setting"), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "invisible_box",
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons_Q2",
    "data-name": "icons Q2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7,34H19a2,2,0,0,0,0-4H9V10H39V30H29a2,2,0,0,0,0,4H41a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2H7A2,2,0,0,0,5,8V32A2,2,0,0,0,7,34Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,38H4a2,2,0,0,0,0,4H44a2,2,0,0,0,0-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9,21.3A5.7,5.7,0,0,0,32,20a5.7,5.7,0,0,0-.1-1.3l-2.2-.5a4.2,4.2,0,0,0-.4-1l1.2-1.9a7.7,7.7,0,0,0-1.8-1.8l-1.9,1.2-1-.4-.5-2.2H22.7l-.5,2.2-1,.4-1.9-1.2a7.7,7.7,0,0,0-1.8,1.8l1.2,1.9a4.2,4.2,0,0,0-.4,1l-2.2.5A5.7,5.7,0,0,0,16,20a5.7,5.7,0,0,0,.1,1.3l2.2.5a4.2,4.2,0,0,0,.4,1l-1.2,1.9a7.7,7.7,0,0,0,1.8,1.8l1.9-1.2,1,.4.5,2.2h2.6l.5-2.2,1-.4,1.9,1.2a7.7,7.7,0,0,0,1.8-1.8l-1.2-1.9a4.2,4.2,0,0,0,.4-1ZM24,22a2,2,0,1,1,2-2A2,2,0,0,1,24,22Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManualTest);
export default __webpack_public_path__ + "static/media/manual_test.c9d0ee30394ba123d2ad75f34cd5638a.svg";
export { ForwardRef as ReactComponent };